import {
  URL_LOGIN,
  URL_FORGOT_PASSWORD,
  URL_CLIENT,
  URL_RE_SEND_EMAIL,
} from "../helpers/endpoint";
import { baseBackend } from "./base/baseUrl";

export const login = async (email, password) => {
  return await baseBackend.post(
    URL_LOGIN,
    JSON.stringify({ email, password, role: 2 }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const registerClient = async (
  email,
  password,
  name,
  lastname,
  phone,
  address,
  country,
  genres_id
) => {
  return await baseBackend.post(
    URL_CLIENT,
    JSON.stringify({
      email,
      password,
      name,
      lastname,
      phone,
      address,
      country,
      company_id: 1,
      genres_id,
    }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const forgotPassword = async (email) => {
  return await baseBackend.post(
    URL_FORGOT_PASSWORD,
    JSON.stringify({ email, role: 2 }),
    {
      headers: { "Content-Type": "application/json" },
      //withCredentials: true,
    }
  );
};

export const reSendConfirmEmail = async (email, urlOrigin) => {
  return await baseBackend.post(
    URL_RE_SEND_EMAIL,
    JSON.stringify({ urlOrigin, email }),
    {
      headers: { "Content-Type": "application/json" },
      //withCredentials: true,
    }
  );
};
